import { render, staticRenderFns } from "./customers_list.vue?vue&type=template&id=0a1bc0e9&scoped=true&"
import script from "./customers_list.vue?vue&type=script&lang=js&"
export * from "./customers_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1bc0e9",
  null
  
)

export default component.exports